var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActionNumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18.57px",
    height: "18.57px",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42871 0.714364H2.143C1.35402 0.714364 0.714425 1.35396 0.714425 2.14294V6.42865C0.714425 7.21763 1.35402 7.85722 2.143 7.85722H6.42871C7.21769 7.85722 7.85728 7.21763 7.85728 6.42865V2.14294C7.85728 1.35396 7.21769 0.714364 6.42871 0.714364Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8572 0.714355H13.5715C12.7825 0.714355 12.1429 1.35395 12.1429 2.14293V6.42864C12.1429 7.21762 12.7825 7.85721 13.5715 7.85721H17.8572C18.6462 7.85721 19.2858 7.21762 19.2858 6.42864V2.14293C19.2858 1.35395 18.6462 0.714355 17.8572 0.714355Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42864 12.1429H2.14293C1.35395 12.1429 0.714355 12.7825 0.714355 13.5715V17.8572C0.714355 18.6462 1.35395 19.2858 2.14293 19.2858H6.42864C7.21762 19.2858 7.85721 18.6462 7.85721 17.8572V13.5715C7.85721 12.7825 7.21762 12.1429 6.42864 12.1429Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8572 12.1429H13.5715C12.7825 12.1429 12.1429 12.7825 12.1429 13.5715V17.8572C12.1429 18.6462 12.7825 19.2858 13.5715 19.2858H17.8572C18.6462 19.2858 19.2858 18.6462 19.2858 17.8572V13.5715C19.2858 12.7825 18.6462 12.1429 17.8572 12.1429Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionNumber);
export default __webpack_public_path__ + "static/media/ActionNumber.c27fea101233b944d5e10c0f00a9f3d7.svg";
export { ForwardRef as ReactComponent };